import { axios } from './config';

export function listAppVersion(params) {
  return axios.post('/appVersion/list_all', params || {}, true)
}

export function saveAppVersion(params) {
  return axios.post('/appVersion/save', params || {}, true)
}

export function updateAppVersion(params) {
  return axios.post('/appVersion/update', params || {}, true)
}

export function deleteAppVersion(id) {
  return axios.post('/appVersion/delete/' + id, {}, true)
}

export function publishAppVersion(id) {
  return axios.post('/appVersion/publish/' + id, {}, true)
}

export function unpublishAppVersion(id) {
  return axios.post('/appVersion/unpublish/' + id, {}, true)
}
